import React from 'react'
import {
    Button,
    VStack,
    HStack,
    Text,
    Box,
    Alert,
    AlertIcon,
    Spinner
} from '@chakra-ui/react'
import adminUsers from 'graphql/queries/adminUsers'
import { useQuery } from '@apollo/client'
import { User } from 'graphql/types'

interface Props {
    userIDs: string[]
    processCampaign: () => void
    testCampaign: () => void
    partnerID?: string
}

export const DraftDetails = ({userIDs, processCampaign, testCampaign, partnerID = 'racq'}: Props) => {
    const result = useQuery(adminUsers, {
        variables: {
            PartnerID: partnerID
        }
    })

    if (!userIDs) {
        return <Box />
    }

    if (result.loading) {
        return (
            <Box p={4} textAlign="center">
                <Spinner />
                <Text mt={2}>Loading users...</Text>
            </Box>
        )
    }

    if (result.error) {
        return (
            <Alert status="error">
                <AlertIcon />
                Error loading users: {result.error.message}
            </Alert>
        )
    }

    if (!result.data?.adminUsers) {
        return (
            <Box p={4}>
                <Text>No users found</Text>
            </Box>
        )
    }

    const users = result.data.adminUsers

    return (
        <VStack spacing={4} align="stretch" p={4} minW="400px">
            <HStack spacing={4}>
                <Button
                    colorScheme="green"
                    flex={1}
                    onClick={processCampaign}
                >
                    Run Campaign
                </Button>
                <Button
                    colorScheme="blue"
                    flex={1}
                    onClick={testCampaign}
                >
                    Test Campaign
                </Button>
            </HStack>

            <Box>
                <Text fontWeight="bold" mb={2}>
                    Recipients:
                </Text>

                {userIDs.length === 0 ? (
                    <Alert status="warning">
                        <AlertIcon />
                        NO EMAILS WILL BE SENT!
                    </Alert>
                ) : (
                    <VStack spacing={2} align="stretch">
                        {userIDs.map((userId) => {
                            const user = users.find((u: User) => u.user_id === userId)
                            return (
                                <Button
                                    key={userId}
                                    variant="outline"
                                    onClick={() => window.open(`/users/${userId}`, '_blank')}
                                    justifyContent="flex-start"
                                >
                                    {user?.email || userId}
                                </Button>
                            )
                        })}
                    </VStack>
                )}
            </Box>
        </VStack>
    )
}
